import api from '../../apiConfig/apiConfig';
import { Post, Get } from '../base/baseAjax';
//获取自建站站点列表
let getGeoSerpList = (params, serviceSiteId) => {
	return Post({
		url: `${api.keywordRanking.geoSerp}?serviceSiteId=${serviceSiteId}`,
		bodyParam: params,
	});
};
// 查看最新服务单  平均排名  关键词排名
let getArgRankAndKey = (params) => {
    return Get({
        url: api.keywordRanking.argRankAndKey,
        UrlParam: params,
    })
}
// 服务单列表  图表
let getServiceEchart = (params, serviceSiteId) => {
	return Post({
		url: `${api.keywordRanking.argRankAndKey}?serviceSiteId=${serviceSiteId}`,
		bodyParam: params,
	});
};
let getKeywordUrlRank = (params, serviceSiteId) => {
	return Post({
		url: `${api.keywordRanking.keywordUrlRank}?serviceSiteId=${serviceSiteId}`,
		bodyParam: params,
	});
};
let getTop10Keyword = (params, serviceSiteId) => {
	return Post({
		url: `${api.keywordRanking.top10Keyword}?serviceSiteId=${serviceSiteId}`,
		bodyParam: params,
	});
};
// 查看快照信息viewPicture
let getviewPicture = params => {
	return Get({
		url: api.keywordRanking.viewPicture,
		PathParam: params,
	});
};

// 添加serp报表任务
let serpReportTask = params => {
	return Post({
		url: api.keywordRanking.serpReportTask,
		bodyParam: params,
	});
};

// serp报表任务列表重新生成
let serpReportTaskListAgain = params => {
	return Post({
		url: api.keywordRanking.serpReportTaskListAgain,
		PathParam: params,
	});
};

export default {
	getGeoSerpList,
	getArgRankAndKey,
	getKeywordUrlRank,
	getTop10Keyword,
	getviewPicture,
	getServiceEchart,
	serpReportTask,
	serpReportTaskListAgain,
};
